// extracted by mini-css-extract-plugin
export var label = "ArticleMeta-module--label--YhmC2";
export var row = "ArticleMeta-module--row--zmnur";